export const MAX_ATTACHMENTS = 4
